import type { PaymentStatus } from '@/types';

// Same labels and colours as the invoices list (InvoicesPage getPaymentStatusDisplay).
const DISPLAY: Record<PaymentStatus, { label: string; color: string }> = {
    PaidFully: { label: 'Paid in Full', color: 'bg-green-100 text-green-800' },
    PartiallyPaid: { label: 'Partially Paid', color: 'bg-amber-100 text-amber-800' },
    PaymentFailed: { label: 'Payment Failed', color: 'bg-red-100 text-red-800' },
    NotPaid: { label: 'Not Paid', color: 'bg-gray-100 text-gray-800' },
};

export function PaymentStatusBadge({ status, title }: { status: PaymentStatus; title?: string }) {
    const { label, color } = DISPLAY[status] ?? DISPLAY.NotPaid;
    return (
        <span title={title} className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ${color}`}>
            {label}
        </span>
    );
}
